module.exports = __webpack_public_path__ + "static/media/51 - Guts - Brand New Revolution.9dd1fab9.mp3";